<template>
  <div class="general">
    <div class="view-reset-password-general">
      <v-navigation-drawer permanent absolute id="v-navigation-drawer-form">
        <v-container fill-height>
          <v-form
            @submit.prevent="resetPassword"
            ref="form"
            :lazy-validation="true"
            class="flex-grow-1 d-flex flex-column align-stretch"
          >
            <v-img
              class="align-self-center mb-9"
              :src="`${appLogo}`"
              :max-height="180"
              :max-width="180"
              :alt="`${appName}`"
            />
            <header class="mb-9 text-center">
              <h1 class="disp-1 mb-3">
                {{ actionTitle }}
              </h1>
              <p class="disp-2">
                {{ actionSubTitle }}
              </p>
            </header>
            <v-alert v-if="message != null" :type="status">
              {{ message }}
            </v-alert>
            <v-text-field
              v-if="!sent"
              v-model="email"
              :label="$t('E-mail')"
              hide-details
              filled
              type="email"
              validate-on-blur
              :rules="[rules.email, rules.required]"
              required
              class="mb-9"
              :color="`${appColor.primary}`"
            />
            <v-btn
              v-if="!sent"
              type="submit"
              :disabled="!validForm"
              :loading="loading"
              :color="`${appColor.primary}`"
              large
              rounded
              class="align-self-center mb-9 px-12 send"
              >{{ $t("Envoyer") }}</v-btn
            >
            <v-img
              v-if="sent"
              class="align-self-center mb-9"
              src="@/assets/email.svg"
              :width="70"
              :height="70"
              alt="email_sent"
            />

            <div v-if="sent" class="align-self-center mb-9">
              <p class="disp-2 sent">
                Vous n’avez pas reçu d’e-mail ? Vérifiez dans vos spam ou
                contactez-nous à
                <a href="mailto:contact@adequation-france.com"
                  >contact@adequation-france.com</a
                >
              </p>
            </div>
            <v-btn
              class="align-self-center"
              v-if="1 == 2"
              :color="`${appColor.secondary}`"
              text
              @click="
                () => {
                  $router.push({
                    name: 'login-general',
                    query: { from: from }
                  });
                }
              "
              >{{ $t("ACCUEIL") }}</v-btn
            >
          </v-form>
        </v-container>
      </v-navigation-drawer>
      <div class="env" :class="env">
        <div>{{ env }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import configGeneral from "@/config/general.json";
import { createNamespacedHelpers } from "vuex";
import { RESET_PASSWORD_GENERAL } from "@/store/action-types";
const { mapActions: mapAuthActions } = createNamespacedHelpers(`auth`);

export default {
  data() {
    return {
      env: process.env.VUE_APP_API_ENV,
      appLogo: require("@/assets/logo-app/logo-adeq.png"),
      appName: "Adequation",
      appColor: { primary: "primary_general", secondary: "secondary_general" },
      token: this.$route.query.token,
      from: this.$route.query.from,
      appFrom:
        configGeneral[this.$route.query.from] ||
        configGeneral["default"] ||
        null,
      loading: false,
      message: null,
      actionTitle: "DEMANDE DE RÉINITALISATION DE MOT DE PASSE",
      actionSubTitle:
        "Entrez l’e-mail associé à votre compte pour recevoir les instructions de réinitialisation de votre mot de passe.",
      sent: false,
      status: null,
      validForm: true,
      email: "",
      rules: {
        required: value => !!value || this.$t("Requis."),
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("Email invalide.");
        }
      }
    };
  },
  beforeMount() {
    //console.log("appFrom:", this.appFrom);
    // display error message
    if (this.token) {
      this.message = this.$t(
        "Le lien a expiré, veuillez recommencer votre demande."
      );
      this.status = "warning";
    }
    //set config from url
    this.appLogo = require("@/assets/logo-app/" + this.appFrom.logo);
    this.appName = this.appFrom.name;
    this.appColor = this.appFrom.color;
  },
  methods: {
    ...mapAuthActions({
      reset: RESET_PASSWORD_GENERAL
    }),
    resetPassword() {
      this.loading = true;
      let callbackPath = this.$router.resolve({ name: "set-password-general" });
      this.reset({
        email: this.email,
        callbackUrl:
          window.location.protocol +
          "//" +
          window.location.host +
          callbackPath.href
      })
        .then(res => {
          if (res.status == "200") {
            this.message = null;
            this.status = null;

            this.actionTitle = "UN E-MAIL VIENT DE VOUS ÊTRE ENVOYÉ !";
            this.actionSubTitle =
              "Vérifiez votre boîte de réception et suivez les instructions pour réinitialiser votre mot de passe.";
            this.sent = true;
          } else if (res.status == "204") {
            this.message = this.$t(
              "Cet adresse email ne correspond à aucun compte."
            );
            this.status = "warning";
          } else {
            this.message = this.$t("Une erreur a eu lieu. Veuillez réessayer.");
            this.status = "error";
          }
        })
        .catch(() => {
          this.message = this.$t("Une erreur a eu lieu. Veuillez réessayer.");
          this.status = "error";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.general {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100;
  height: 100%;
  margin: auto;
  background-color: white;
}

.view-reset-password-general {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // background: url("~@/assets/login-background.jpg") no-repeat center right/cover;
  // text-align: center;
  width: 424px;
  height: 70%;
  margin: auto;

  .env {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: rgb(255, 255, 255);
    height: 96px;
    width: 96px;
    border-radius: 50%;

    position: fixed;
    left: 8px;
    // bottom: 8px;
  }

  .LOCAL {
    background-color: #c41c00;
    opacity: 0.8;
  }
  .DEV,
  .RCT {
    background-color: #c41c00;
    opacity: 0.8;
  }
  .PROD {
    background-color: rgb(255, 255, 255);
    visibility: hidden;
  }

  .v-content {
    background-color: white;
  }

  .container {
    display: flex !important;
  }

  #v-navigation-drawer-form {
    width: 100% !important;
    //margin: 0 auto;
  }
  .disp-1 {
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-align: center;
  }
  .disp-2 {
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-align: center;
  }

  .sent.disp-2 {
    font-size: 12px;
    a:link {
      text-decoration: underline;
      color: black;
    }
    a:visited {
      color: black;
      text-decoration: underline;
    }
    a:hover {
      color: black;
      text-decoration: underline;
    }
    a:active {
      color: black;
      text-decoration: underline;
    }
  }

  .v-navigation-drawer__border {
    background: none !important;
  }

  .send .v-btn__content {
    color: white;
  }

  .v-image__image {
    background-size: contain;
  }
}
</style>
